<!--
# Module: 水量信息查询
-->
<template>
  <div class="manage-page">
    <div class="page-view">
      <div class="item-row" v-for="w in navMenu" :key="w.id" @click="opendialog(w.id)">
        <div class="name">
          <span>{{w.title}}</span>
        </div>
        <p class="tips">{{w.dec}}</p>
      </div>
    </div>
    <div class="dialogform">
      <el-dialog
        v-if="dialog"
        :title="dialogtitle"
        :visible.sync="dialog"
        top="0"
        width="1200px"
        :before-close="handlecancel"
      >
        <!-- 用水水量 -->
        <div class="water-quantity" v-if="dialogname == 'waterquantity_information'">
          <!-- 表单 -->
          <el-form :inline="true" :model="formData" class="demo-form-inline">
            <el-form-item label="数据月份" prop="months">
              <el-date-picker
                v-model="formData.months"
                format="yyyy 年 MM 月"
                value-format="timestamp"
                type="monthrange"
                size="small"
                range-separator="至"
                start-placeholder="开始月份"
                end-placeholder="结束月份"
              ></el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onsearch('month')" size="small">查询</el-button>
            </el-form-item>
          </el-form>
          <el-divider />
          <!-- 表格 -->
          <el-table
            ref="Watermeterlistref"
            :data="tableData"
            highlight-current-row
            :fit="false"
            stripe
            max-height="500"
            border
            size="mini"
          >
            <el-table-column
              align="center"
              :resizable="false"
              show-overflow-tooltip
              label="#"
              type="index"
              width="50"
            ></el-table-column>
            <el-table-column
              prop="code"
              align="center"
              :resizable="false"
              show-overflow-tooltip
              label="用户编码"
              width="150"
            ></el-table-column>
            <el-table-column
              prop="name"
              align="center"
              :resizable="false"
              show-overflow-tooltip
              label="用户名称"
              width="200"
            ></el-table-column>
            <el-table-column
              prop="user_code"
              align="center"
              :resizable="false"
              show-overflow-tooltip
              label="计划户编码"
              width="120"
            ></el-table-column>
            <el-table-column
              prop="user_name"
              align="center"
              :resizable="false"
              show-overflow-tooltip
              label="计划户名称"
              width="200"
            ></el-table-column>
            <el-table-column
              prop="times"
              align="center"
              :resizable="false"
              show-overflow-tooltip
              label="月份"
              width="120"
            ></el-table-column>
            <el-table-column
              prop="usewater"
              align="center"
              :resizable="false"
              show-overflow-tooltip
              label="水量(T)"
              width="120"
            ></el-table-column>
            <el-table-column
              prop="measure"
              align="center"
              :resizable="false"
              show-overflow-tooltip
              label="分日计量(m³)"
              width="200"
            ></el-table-column>
            <el-table-column
              prop="meter_price"
              align="center"
              :resizable="false"
              show-overflow-tooltip
              label="供水单价(元)"
              width="120"
            ></el-table-column>
            <el-table-column
              prop="usewater_id"
              align="center"
              :resizable="false"
              show-overflow-tooltip
              label="用水性质"
              width="100"
            ></el-table-column>
            <el-table-column
              prop="start_metercode"
              align="center"
              :resizable="false"
              show-overflow-tooltip
              label="起码(T)"
              width="120"
            ></el-table-column>
            <el-table-column
              prop="start_time"
              align="center"
              :resizable="false"
              show-overflow-tooltip
              label="起码抄表日期"
              width="120"
            ></el-table-column>
            <el-table-column
              prop="end_metercode"
              align="center"
              :resizable="false"
              show-overflow-tooltip
              label="止码(T)"
              width="120"
            ></el-table-column>
            <el-table-column
              prop="end_time"
              align="center"
              :resizable="false"
              show-overflow-tooltip
              label="止码抄表日期"
              width="120"
            ></el-table-column>
            <el-table-column
              prop="meter_dn"
              align="center"
              :resizable="false"
              show-overflow-tooltip
              label="口径"
              width="100"
            ></el-table-column>
          </el-table>
          <!-- 分页器 -->
          <el-pagination
            class="page"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-size="pageSize"
            :background="true"
            layout="total, prev, pager, next, jumper"
            hide-on-single-page
            :total="dataTotal"
          ></el-pagination>
        </div>
        <!-- 水表用水情况 -->
        <div class="water-tablemeter" v-if="dialogname == 'waterquery_meter'">
          <div class="water-head">
            <p>
              <span>年份:</span>
              <el-date-picker
                size="small"
                v-model="yearvalue.s_year"
                type="year"
                placeholder="开始年份"
                class="pickerYeare"
                @change="handleYear('begin')"
              ></el-date-picker>至
              <el-date-picker
                size="small"
                v-model="yearvalue.e_year"
                type="year"
                placeholder="结束年份"
                class="pickerYeare"
                @change="handleYear('end')"
              ></el-date-picker>
              <el-button type="primary" @click="onsearch('years')" size="small">查询</el-button>
            </p>
            <el-row>
              <el-col :span="12">用户编号：{{this.userInfo.code}}</el-col>
              <el-col :span="12">用户名称：{{this.userInfo.name}}</el-col>
              <el-col :span="24">用户地址：{{this.userInfo.addr_detail}}</el-col>
            </el-row>
          </div>
          <el-divider />
          <div class="water-body">
            <table class="table-box" v-for="(e, i) in meterData" :key="i">
              <tr>
                <td colspan="13" class="text-center">{{e.year}}年度各月用水量(单位：m³)</td>
              </tr>
              <tr>
                <td colspan="1" class="text-center">水表编号</td>
                <td colspan="1" class="text-center">1月</td>
                <td colspan="1" class="text-center">2月</td>
                <td colspan="1" class="text-center">3月</td>
                <td colspan="1" class="text-center">4月</td>
                <td colspan="1" class="text-center">5月</td>
                <td colspan="1" class="text-center">6月</td>
                <td colspan="1" class="text-center">7月</td>
                <td colspan="1" class="text-center">8月</td>
                <td colspan="1" class="text-center">9月</td>
                <td colspan="1" class="text-center">10月</td>
                <td colspan="1" class="text-center">11月</td>
                <td colspan="1" class="text-center">12月</td>
              </tr>
              <tr v-for="(t, r) in e.water" :key="r">
                <td colspan="1" class="text-center">{{t.code}}</td>
                <td colspan="1" class="text-center">{{t.month_1}}</td>
                <td colspan="1" class="text-center">{{t.month_2}}</td>
                <td colspan="1" class="text-center">{{t.month_3}}</td>
                <td colspan="1" class="text-center">{{t.month_4}}</td>
                <td colspan="1" class="text-center">{{t.month_5}}</td>
                <td colspan="1" class="text-center">{{t.month_6}}</td>
                <td colspan="1" class="text-center">{{t.month_7}}</td>
                <td colspan="1" class="text-center">{{t.month_8}}</td>
                <td colspan="1" class="text-center">{{t.month_9}}</td>
                <td colspan="1" class="text-center">{{t.month_10}}</td>
                <td colspan="1" class="text-center">{{t.month_11}}</td>
                <td colspan="1" class="text-center">{{t.month_12}}</td>
              </tr>
            </table>
          </div>
          <el-divider />
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  A_ADD_Waterconsumption, // 查询用水量
  A_PUL_QueryBusinessWaterByyear // 通过计划户和年份查询营业水量列表
} from '@/assets/js/axiosPresets'
export default {
  name: "waterUsageQueryMessage",
  data () {
    return {
      dialogtitle: "", // 弹框标题
      dialogname: "", // 弹框名称（做区别）
      dialog: false, // 是否显示弹框
      yearvalue: { s_year: '', e_year: '' },
      meterData: [], // 各个水表年份数据集合
      formData: { months: '' }, // 表单(筛选)
      tableData: [], // 表格数据
      curtableData: [], // 当前table 缓数据 
      currentPage: 1, // 当前页数
      dataTotal: 0, // 数据总条数
      pageData: [], // table分页数据
      userInfo: null // 用户信息
    }
  },
  created () {
    this.$initReload()
  },
  computed: {
    // 用户信息
    basicsUser () {
      return this.$store.state.userInfo
    },
    // 选项卡：菜单导航
    navMenu () {
      return [
        // { id: 'waterquantity_information', title: '查询用水水量信息', dec: '查询计划户名下的水量信息' },
        { id: 'waterquery_meter', title: '查询水表用水情况信息', dec: '查询计划户名下的水表用水情况信息' }
      ]
    },
    // 分页：单页数据量
    pageSize () {
      return 20
    }
  },
  watch: {
    // 监听用户信息
    basicsUser (v) {
      this.userInfo = this.$initUserInfo()
      this.$get_Waterconsumption()
      this.$yeasr()
    },
    // 监听分页(解决初始页面数据)
    pageData (v) {
      this.handleCurrentPageData()
    }
  },
  mounted () {
    if (this.userInfo) {
      this.$get_Waterconsumption()
      this.$yeasr()
    }
  },
  methods: {
    // 格式化时间
    $filterTime (val, type) {
      let time = "--"
      if (val) {
        let timestamp = new Date(val)
        let year = timestamp.getFullYear()
        let month = timestamp.getMonth() + 1
        month = month < 10 ? "0" + month : month
        let day = timestamp.getDate()
        day = day < 10 ? "0" + day : day
        let hour = timestamp.getHours()
        hour = hour < 10 ? "0" + hour : hour
        let minutes = timestamp.getMinutes()
        minutes = minutes < 10 ? "0" + minutes : minutes

        switch (type) {
          case "yyyy-MM-dd":
            time =
              year.toString() + "-" + month.toString() + "-" + day.toString()
            break
          case "yyyy-MM":
            time =
              year.toString() + "年" + month.toString() + "月"
            break
          case "YYYY-MM":
            time =
              year.toString() + "年" + month.toString() + "月"
            break
          case "hh:mm":
            time = hour.toString() + ":" + minutes.toString()
            break
        }
      }
      return time
    },
    // 初始化：页面加载当前用户信息
    $initReload () {
      if (!this.userInfo) {
        this.userInfo = this.$store.state.userInfo
      }
    },
    // 初始化：获取基本信息(页面刷新加载)
    $initUserInfo () {
      if (this.$store.state.userInfo) {
        return this.$store.state.userInfo
      }
    },
    // 初始化：默认年份
    $yeasr () {
      let _Begin = (new Date()).getFullYear() - 2 + ""
      let _End = new Date().getFullYear() + ""
      this.yearvalue.s_year = new Date(_Begin)
      this.yearvalue.e_year = new Date(_End)
      this.$get_WaterData(parseInt(_Begin), parseInt(_End))
    },
    // 数据：请求用水量接口
    async $get_Waterconsumption () {
      const wid = await A_ADD_Waterconsumption({ user_id: this.userInfo.oid })
      let returnData = JSON.parse(JSON.parse(wid.data.d).resultMaps)
      returnData.filter(e => {
        e.times = this.$filterTime(e.record_date, "yyyy-MM")
        e.usewater_id = this.userInfo.usewater_id
        e.user_code = this.userInfo.code
        e.user_name = this.userInfo.name
        e.usewater_id = this.userInfo.usewater_id
      })
      this.handleCreateDataPage(returnData)
      this.tableData = returnData
      this.curtableData = returnData
    },
    // 数据：请求用水量数据信息
    async $get_WaterData (s, e) {
      const res = await A_PUL_QueryBusinessWaterByyear({ s_year: s, e_year: e, user_id: this.userInfo.oid })
      // debugger
      const meterList = res.data.Content.meter_list
      const waterList = res.data.Content.water_list
      const tableData = this.beautyWaterData([s, e], meterList, waterList)
      console.log(tableData)
      this.meterData = tableData
    },
    // 数据：处理各个水表信息
    beautyWaterData (year, meterList, waterList) {
      let s_year = year[0]
      let e_year = year[1]
      const waterMap = new Map()
      waterList.forEach(water => {
        const key = String(new Date(water.record_date).format('yyyy-M')) + '-' + String(water.meter_id)
        waterMap.set(key, water.usewater)
      })
      const waterData = []
      for (let y = s_year; y < e_year + 1; y++) {
        const yearData = {
          year: y,
          water: []
        }
        meterList.forEach(meter => {
          const meterRow = {}
          meterRow.oid = meter.meter_id
          meterRow.code = meter.code
          Array(12).fill(1).forEach((item, index) => {
            const mKey = [y, (index + 1), meter.meter_id].join('-')
            const rKey = 'month_' + (index + 1)
            const val = waterMap.get(mKey) || null
            meterRow[rKey] = val
          })
          yearData.water.push(meterRow)
        })
        waterData.push(yearData)
      }
      return waterData
    },
    // 功能: 打开弹框,赋值
    opendialog (e) {
      this.dialogname = e
      switch (e) {
        case 'waterquantity_information':
          this.dialogtitle = '营收水量信息'
          break
        case 'waterquery_meter':
          this.dialogtitle = '水表用水情况'
          break
      }
      this.dialog = true
    },
    // 功能：选择年份
    handleYear (t) {
      let _begin = this.yearvalue.s_year ? this.yearvalue.s_year.getFullYear() : ''
      let _end = this.yearvalue.e_year ? this.yearvalue.e_year.getFullYear() : ''
      switch (t) {
        case 'begin':
          if (_end) {
            if (_end < _begin) {
              this.yearvalue.s_year = null
              this.$message({
                message: '开始时间不能大于结束时间，请重新选择年份！',
                type: 'warning'
              })
            }
          }
          break
        case 'end':
          if (_begin) {
            if (_begin > _end && _end !== '') {
              this.yearvalue.e_year = null
              this.$message({
                message: '结束时间不能小于开始时间，请重新选择年份！',
                type: 'warning'
              })
              console.log(_begin, _end, '4444')
            }
          }
          break
      }
    },
    // 功能：筛选后的数据分页
    handleCreateDataPage (data) {
      let _pageData = []
      let _page = []
      let n = 0
      data.forEach(item => {
        _page.push(item)
        n++
        if (n % this.pageSize === 0 || n === data.length) {
          _pageData.push(_page)
          _page = []
        }
      })
      this.dataTotal = data.length
      this.pageData = _pageData
    },
    // 功能：设置当前分页数据
    handleCurrentPageData () {
      this.tableData = this.pageData[this.currentPage - 1]
    },
    // 功能：分页(当前页数)
    handleCurrentChange (val) {
      this.currentPage = Number(`${val}`)
      this.handleCurrentPageData()
    },
    // 功能 : 重置数据（取消）
    handlecancel () {
      this.dialog = false
    },
    // 功能：搜索按钮事件
    onsearch (e) {
      switch (e) {
        case 'month':
          debugger
          if (this.formData.months) {
            let _tableData = []
            let _begin = this.formData.months[0]
            let _end = this.formData.months[1]
            let _Data = this.curtableData
            _Data.filter(e => {
              if (new Date(e.record_date).getTime() >= _begin && new Date(e.record_date).getTime() <= _end) {
                _tableData.push(e)
              }
            })
            this.handleCreateDataPage(_tableData)
          } else {
            this.handleCreateDataPage(this.curtableData)
          }
          break
        case 'years':
          if (!this.yearvalue.s_year || !this.yearvalue.e_year) {
            this.$message({
              message: '年份不能为空，请重新选择年份！',
              type: 'warning'
            })
            return false
          } else {
            this.$get_WaterData(this.yearvalue.s_year.getFullYear(), this.yearvalue.e_year.getFullYear())
          }
          break
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.water-body {
  overflow-y: auto;
  max-height: 500px;
  padding: 20px 0px;
  margin: 0 auto;
  td {
    padding: 5px 10px;
    line-height: 24px;
    box-sizing: border-box;
    vertical-align: middle;
    border: 1px solid #000000;
  }
  .table-box {
    width: 100%;
  }
  .table-item {
    width: 100%;
  }
  .text-center {
    text-align: center;
  }
}
.water-head {
  width: 100%;
  height: 100%;
  > p > span {
    padding-right: 25px;
  }
  > p > .pickerYeare {
    width: 180px;
  }
}
</style>